@use "../../../../globals/bcp";

:host {
  display: block;
}

.o-logo {
  display: block;

  &__image {
    width: 100%;
    height: 100%;
    display: block;
  }
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
